'use client';

import React, { useEffect } from 'react';

import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';

interface PostHogProviderProps {
  children: React.ReactNode;
}

let posthogInitialized = false;

export function PostHogProvider({ children }: PostHogProviderProps) {
  // Initialise PostHog once on the client
  useEffect(() => {
    if (posthogInitialized) return;

    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
      api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
      person_profiles: 'always',
    });
    // Start capturing session replays
    posthog.startSessionRecording();
    if (process.env.NODE_ENV === 'development') {
      // Log detailed PostHog debug output in the console
      posthog.debug();
    }
    posthogInitialized = true;
  }, []);

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
